export default __webpack_public_path__ + "static/media/germantownFridge.cc39cf0f.jpg";